import { Component } from '@angular/core';

@Component({
  selector: 'app-dropdown-menu1',
  templateUrl: './dropdown-menu1.component.html',
})
export class DropdownMenu1Component {
  // Define filter options with their initial states
  filters = {
    showID: true,
    showType: true,
    showCreated: true,
    showModified: true,
    showStatus: true,
    showPhone: true,
    showDuration: true,
    showAttempts: true,
    showEliotID: false,
    showEliotName: false,
    showEliotSurname: false,
    showEliotCompany: false,
    showEliotLink: false,
    showEliotSync: false,
    showEliotSyncDate: false,
    showContactCampaignFrom: false,
    showContactEmail: false,
    showContactJobFor: false,
    showContactLanguageGrade: false,
    showContactName: false,
    showContactSource: false,
    showContactSubmit: false,
    showContactSurname: false,
  };

  campaignModule: string | null = 'default'; // Adjust based on the campaign module logic

  // Function to apply filters
  applyFilters(): void {
    console.log('Filters applied:', this.filters);
    // Add any logic needed to update the view or data based on the applied filters
  }

  // Function to reset filters to their default state
  resetFilters(): void {
    this.filters = {
      showID: true,
      showType: true,
      showCreated: true,
      showModified: true,
      showStatus: true,
      showPhone: true,
      showDuration: true,
      showAttempts: true,
      showEliotID: false,
      showEliotName: false,
      showEliotSurname: false,
      showEliotCompany: false,
      showEliotLink: false,
      showEliotSync: false,
      showEliotSyncDate: false,
      showContactCampaignFrom: false,
      showContactEmail: false,
      showContactJobFor: false,
      showContactLanguageGrade: false,
      showContactName: false,
      showContactSource: false,
      showContactSubmit: false,
      showContactSurname: false,
    };
  }
}
